interface HeartbeatTimerParams {
  intervalTime: number;
  callbackFn: () => void;
}

interface HeartbeatTimer {
  start: () => void;
  stop: () => void;
}

let heartbeatTimer: HeartbeatTimer | null = null;

export const HeartbeatTimer = (params: HeartbeatTimerParams): HeartbeatTimer => {
  if (heartbeatTimer != null) {
    return heartbeatTimer;
  }

  let heartbeatIntervalId: NodeJS.Timeout | null = null;
  const {intervalTime, callbackFn} = params;
  const start = (): void => {
    if (heartbeatIntervalId === null) {
      heartbeatIntervalId = setInterval(callbackFn, intervalTime);
    }
  };

  const stop = (): void => {
    if (heartbeatIntervalId == null) {
      throw new Error('Heartbeat Timer not initialized');
    } else {
      clearInterval(heartbeatIntervalId);
      heartbeatIntervalId = null;
    }
  };
  heartbeatTimer = {
    start: start,
    stop: stop,
  };
  return heartbeatTimer;
};
